module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel4-fr-FR@2x-01d11caaafb2abf5227c4f33220c71c6.png";